import React, { useEffect, useState, useRef } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  ChevronDoubleRightIcon,
  ChevronDoubleLeftIcon,
} from "@heroicons/react/24/solid";
import CustomBigText from "../sharedComponents/customBigText";
import StarReview from "../sharedComponents/customReviewStars";
import image from "../../assets/images/Polygon 6.png";
import image2 from "../../assets/images/Polygon 5.png";
import { useTranslation } from "react-i18next";
import main from "../../assets/images/Group 1000016289.jpg";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllFeedback } from "../../redux/reducer/feedbackReducer";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

export default function CustomReviewsSection() {
  const scrollRef = useRef(null);
  const [scrollIndex, setScrollIndex] = useState(0);
  // const itemsPerScroll = 3; // Number of items per scroll action
  const [itemsPerScroll, setItemsPerScroll] = useState(3);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 640 && window.innerWidth < 1024
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { allFeedback } = useSelector((state) => state.feedback);
  const numberOfDots = Math.ceil(allFeedback.length / itemsPerScroll);

  const language = localStorage.getItem("language") || "ar";
  const direction = useLanguageDirection();
  const navigateWithLang = useLanguageNavigate();

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchAllFeedback());
    };

    fetchData();
  }, [dispatch]);

  // console.log(allFeedback)

  useEffect(() => {
    setScrollIndex(0);
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ left: 0, behavior: "smooth" });
    }
  }, [itemsPerScroll]);

  useEffect(() => {
    const updateDeviceSettings = () => {
      const width = window.innerWidth;

      if (width < 640) {
        setItemsPerScroll(1);
        setIsMobile(true);
        setIsTablet(false);
      } else if (width >= 640 && width < 1024) {
        setItemsPerScroll(2);
        setIsMobile(false);
        setIsTablet(true);
      } else {
        setItemsPerScroll(3);
        setIsMobile(false);
        setIsTablet(false);
      }
    };

    updateDeviceSettings(); // Run on mount
    window.addEventListener("resize", updateDeviceSettings);

    return () => window.removeEventListener("resize", updateDeviceSettings);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
      setIsTablet(window.innerWidth >= 640 && window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      updateScrollIndex();
    };
    const container = scrollRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll, { passive: true });
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [itemsPerScroll, numberOfDots]);
  const scrollOneItem = (direction) => {
    if (scrollRef.current) {
      const itemWidth = scrollRef.current.children[0].offsetWidth;
      const scrollAmount =
        direction === "left"
          ? -itemWidth * itemsPerScroll
          : itemWidth * itemsPerScroll;

      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });

      setScrollIndex((prevIndex) => {
        let newIndex = direction === "left" ? prevIndex - 1 : prevIndex + 1;
        if (newIndex < 0) newIndex = numberOfDots - 1;
        if (newIndex >= numberOfDots) newIndex = 0;
        return newIndex;
      });
    }
  };

  const scrollToIndex = (index) => {
    if (scrollRef.current) {
      const itemWidth = scrollRef.current.children[0].offsetWidth;
      scrollRef.current.scrollTo({
        left: index * itemWidth * itemsPerScroll,
        behavior: "smooth",
      });
      setScrollIndex(index);
    }
  };

  const updateScrollIndex = () => {
    if (scrollRef.current) {
      const scrollLeft = scrollRef.current.scrollLeft;
      const itemWidth = scrollRef.current.children[0].offsetWidth;

      const pageWidth = itemWidth * itemsPerScroll;

      const newIndex = Math.round(scrollLeft / pageWidth);

      const maxIndex = numberOfDots - 1;
      setScrollIndex(Math.max(0, Math.min(newIndex, maxIndex)));
    }
  };

  useEffect(() => {
    const handleScroll = () => updateScrollIndex();
    const container = scrollRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="relative bg-[#121212] ">
      <img
        src={main}
        alt="Background"
        className="absolute inset-0 z-0 object-cover w-full h-full"
        style={{ opacity: 0.03 }}
        loading="lazy"
      />
      <div className="relative z-10 items-center justify-center w-full pb-2">
        <div className="flex flex-col items-center justify-center text-center px-custom-padding">
          <div className="flex items-center justify-between" dir="ltr">
            {/* Line 1 */}
            <div className="bg-yellow-50 w-[4px] h-[60px] md:h-[100px] mr-24 lg:mr-40"></div>
            {/* Space Between */}
            <div className="bg-yellow-50 w-[4px] h-[60px] md:h-[100px]"></div>
          </div>
          {/* <CustomBigText title={t("customerFeedback")} link={true} /> */}
          <div className="inline-block px-4 py-2 bg-custom-yellow md:px-8 min-w-[300px]">
            <button
              onClick={() => navigateWithLang("/testimonials")}
              className="text-lg font-bold text-center text-black md:text-xl lg:text-3xl"
            >
              {t("testimonials")}
            </button>
          </div>
          <div className="items-center justify-center px-1 mx-2 mt-10 mb-20 lg:px-8">
            <div className="relative flex items-center">
              {/* Left Arrow */}
              <button
                onClick={() => scrollOneItem("left")}
                className="absolute hidden lg:block lg:left-[-50px]
                  mr-4 lg:mr-12 z-10 p-2 text-white bg-primary-color rounded-full shadow-md focus:outline-none"
              >
                <ChevronDoubleLeftIcon className="w-5 h-5 lg:w-10 lg:h-10" />
              </button>

              <div
                ref={scrollRef}
                className="flex items-center w-full gap-6 overflow-x-auto scrollbar-hidden"
                dir="ltr"
                style={{
                  maxWidth: isMobile
                    ? "calc(1 * 290px + 1 * 30px)" // Full width for mobile (1 item)
                    : isTablet
                    ? "calc(2 * 290px + 1 * 30px)" // Width for 2 items on tablet
                    : "calc(3 * 290px + 2 * 30px)", // Width for 3 items on desktop
                  scrollSnapType: "x mandatory",
                }}
              >
                {allFeedback.map((Feedback) => (
                  <div className="flex flex-col bg-transparent ">
                    <div
                      key={Feedback.id}
                      className="flex-none w-[290px] sm:w-[250px] lg:w-[290px]
                    bg-white rounded-lg shadow-lg p-4 my-5"
                      style={{ scrollSnapAlign: "start" }}
                    >
                      <div className="flex flex-col items-center justify-center my-5">
                        <h2 className="items-center justify-center w-8 h-8 text-2xl text-center text-black rounded-full bg-custom-yellow">
                          ,,
                        </h2>
                        <h2
                          className="mt-2 font-normal text-gray-700 cursor-pointer lg:text-lg xl:text-lg 1xl:text-xl 11xl:text-xl 2xl:text-xl"
                          // onClick={handleClick}
                          dir={direction}
                        >
                          {language === "ar"
                            ? Feedback.name.ar
                            : Feedback.name.en}
                        </h2>
                        <h2
                          className="mt-2 mb-3 text-sm font-semibold text-gray-700 cursor-pointer lg:text-base "
                          // onClick={handleClick}
                          dir={direction}
                        >
                          {language === "ar"
                            ? Feedback.desc.ar
                            : Feedback.desc.en}
                        </h2>
                        <StarReview rate={Feedback.rate} />
                      </div>
                    </div>

                    <div
                      className="flex items-center justify-center"
                      dir={direction === "rtl" ? "ltr" : "rtl"}
                    >
                      <img
                        src={direction === "rtl" ? image : image2}
                        alt="image"
                        className="relative top-[-32px]"
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* Right Arrow */}
              <button
                onClick={() => scrollOneItem("right")}
                className="absolute hidden lg:block lg:right-[-50px] ml-4 lg:ml-12 
                  z-10 p-2 text-white bg-primary-color rounded-full shadow-md focus:outline-none"
              >
                <ChevronDoubleRightIcon className="w-5 h-5 lg:w-10 lg:h-10" />
              </button>
            </div>

            {/* Dots Container */}
            <div
              className="flex justify-center mt-4"
              dir={direction === "rtl" ? "ltr" : "rtl"}
            >
              {Array.from({ length: numberOfDots }).map((_, index) => (
                <div
                  key={index}
                  onClick={() => scrollToIndex(index)}
                  className={`w-3 h-3 mx-1 rounded-full cursor-pointer ${
                    index === scrollIndex ? "bg-custom-yellow" : "bg-gray-100"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
